// The EXACT local-first increment UPDATE the PowerSync capture adapter ships.
//
// Extracted to a single source of truth (audit-1 #1/#5) so three consumers bind
// to the same statement and cannot drift apart:
//   - the production adapter (capture-client-powersync.ts flushCoalesce);
//   - the SQL-shape unit test (capture-client-powersync-flush.test.ts);
//   - the real-engine @powersync/node test (capture-item-metadata-real-engine
//     .test.ts) that proves the engine actually surfaces `_metadata` in
//     CrudEntry.metadata while value-diffing the FK columns out of opData.
//
// `_metadata = json_object(<the row's OWN FK columns>)` snapshots the immutable
// FK context (building/space/asset_type/session/site + captured_at) onto this
// PATCH's CRUD entry while the local row is still present. PowerSync value-diffs
// the unchanged FK columns OUT of opData, and by the time the connector 404s the
// PATCH on reconnect sync may have deleted the local row — so without this snapshot
// quarantineUnsyncableCount records a context-less "bare" recovery row Phase-2
// placement can never place. `metadata` is NOT value-diffed and survives the row's
// deletion in the upload queue. SQLite evaluates the json_object() column
// references against the PRE-UPDATE row values, and the FK columns are NOT in the
// SET list, so they are read-not-written (no value change, no LWW effect).
// Requires `trackMetadata: true` on capture_items (schema.ts) — without it the
// `_metadata` SET is a silent no-op and bare rows return.
//
// Param order: [quantity, is_zero_confirmed, notes, sync_version, id].
export const CAPTURE_ITEM_INCREMENT_UPDATE_SQL = `UPDATE capture_items
         SET quantity = ?,
             is_zero_confirmed = ?,
             notes = ?,
             sync_version = ?,
             updated_at = strftime('%Y-%m-%dT%H:%M:%fZ','now'),
             _metadata = json_object(
               'capture_session_id', capture_session_id,
               'site_id', site_id,
               'building_id', building_id,
               'space_id', space_id,
               'asset_type_id', asset_type_id,
               'captured_at', captured_at)
         WHERE id = ?`
